$ = require('jquery');

$(() => {
    let sideNavDesktop = $('.side-navigation--desktop');
    let verticalPageDis = $('.vertical-page-disclaimer');
    let pageSectionGrid = $('.page-section > .wp-block-jetpack-layout-grid');
    let headerHeadline = $('.header-headline');
    let pageSectionHeadline = $('.wp-block-lazyblock-main-headline');

    // * -------------------->
    // ? add specific class to header-headline parent
    headerHeadline.parent('.wp-block-lazyblock-main-headline').addClass('wp-block-lazyblock-header-headline');
    // * -------------------->



    // * -------------------->
    // ? if header-headline exists then add the height of it as a padding to vertical-page-disclaimer--text (in mobile viewport)
    const verticalPageDisHeight = () => {
        if (headerHeadline.length > 0 && $(window).width() < 1080) {
            verticalPageDis.addClass('height'); 
        } else {
            verticalPageDis.removeClass('height'); 
        }
    }
    verticalPageDisHeight();
    // * -------------------->



    // * -------------------->
    // ? adding two GRID blocks basically for GRID lines
    pageSectionGrid.append('<div class="line-col-left"></div><div class="line-col-right"></div>');
    pageSectionHeadline.append('<div class="line-col-left"></div><div class="line-col-right"></div>');
    // * -------------------->



    // * -------------------->
    // ? when in desktop view, remove .img-shadow-left/.img-shadow-right
    const checkImgShadow = () => {
        const toggleOperations = (target, orientation) => {
            let section = target.firstElementChild;
            if ($(window).width() < 1080) {
                if (section.parentElement.classList.contains(`no-img-shadow-${orientation}`)) {
                    section.parentElement.classList.add(`img-shadow-${orientation}`);
                    section.parentElement.classList.remove(`no-img-shadow-${orientation}`);
                }
            }
            if ($(window).width() >= 1080) {
                if (section.parentElement.classList.contains(`img-shadow-${orientation}`)) {
                    section.parentElement.classList.add(`no-img-shadow-${orientation}`);
                    section.parentElement.classList.remove(`img-shadow-${orientation}`);
                }
            }
        }
        $('.img-shadow-left').each((index, left) => {
            toggleOperations(left, 'left');
        });
        $('.img-shadow-right').each((index, right) => {
            toggleOperations(right, 'right');
        });
        $('.no-img-shadow-left').each((index, left) => {
            toggleOperations(left, 'left');
        });
        $('.no-img-shadow-right').each((index, right) => {
            toggleOperations(right, 'right');
        });
    };
    checkImgShadow();
    // * -------------------->



    // * -------------------->
    // ? add padding to entry-content, vertical-page-disclaimer and side-navigation--desktop when sticky-header gets activated and vice versa
    $(".sticky-header").on("sticky.zf.stuckto:top", () => {
        // console.log('sticky-header stuck');
        sideNavDesktop.css('padding-top', '104px');
        verticalPageDis.css('padding-top', '104px');
    });
    $(".sticky-header").on("sticky.zf.unstuckfrom:top", () => {
        // console.log('sticky-header unstuck');
        sideNavDesktop.css('padding-top', '0');
        verticalPageDis.css('padding-top', '0');
    });
    // * -------------------->



    // * -------------------->
    // ? products page with ellipsis columns, if p height is 128px then add read more
    const ellipsisColsGroup = $('.ellipsis-on-column .wp-block-jetpack-layout-grid-column .wp-block-group');

    setTimeout(() => {
        for (let group of ellipsisColsGroup) {
            let currentBG = group.parentElement.parentElement.parentElement.parentElement.style.backgroundColor;
            currentBG === 'rgba(0, 0, 0, 0)' ? currentBG = 'var(--global--color-background)' : currentBG = currentBG;
            console.log('group', group)
            if (group.offsetHeight === 123 && group.querySelector('.wp-block-group__inner-container').offsetHeight > 125) {
                $(group).append(`<span style="background-color: ${currentBG}" class="ellipsis-on-column--read-more">... <a>${app_translation.readMore}</a></span>`);
            }

            $(group).find('.ellipsis-on-column--read-more').on('click', function() {
                let box = this.parentElement, readMore = $(this);

                if (window.getComputedStyle(box, null).maxHeight === 'none') {
                    $(box).css('max-height', '123px');
                    readMore.html(`... <a>${app_translation.readMore}</a>`);
                } else {
                    $(box).css('max-height', 'none');
                    readMore.html(`<a>${app_translation.readLess}</a>`);
                }
            })
        }
    }, 500)
    // * -------------------->



    // * -------------------->
    // ? do stuff when element appears on scroll
    const elementTop = (element) => {
        let elementTopPoint = $(element).offset().top;
        let elementBottomPoint = $(element).offset().top + $(element).outerHeight();
        let screenTop = $(window).scrollTop();
        let screenBottom = $(window).scrollTop() + $(window).innerHeight();
    
        if ((screenBottom > elementTopPoint) && (screenTop < elementBottomPoint)) {
            return true;
        } else {
            return false;
        }
    }
    $(window).on('scroll', () => {
        if (elementTop('#footer')) {
            sideNavDesktop.fadeOut(500);
            verticalPageDis.fadeOut(500);
        } else {
            sideNavDesktop.fadeIn(500);
            verticalPageDis.fadeIn(500);
        }
    });
    // * -------------------->



    // * -------------------->
    // ? make a grid inside a right stretched columns and calculate amount of columns inside that grid
    const pageSection = $('.page-section');
    const gridColSide = $('.page-section > .wp-block-jetpack-layout-grid').find('div.wp-block-jetpack-layout-grid-column').find('.wp-block-lazyblock-section-title');

    let gridColRight;
    let gridColRightStart;
    let gridColRightEnd;
    let gridColRightChild;

    let gridColLeft = $('.page-section > .wp-block-jetpack-layout-grid').find('div.wp-block-jetpack-layout-grid-column:first');
    let gridColLeftStart;
    let gridColLeftEnd;
    let gridColLeftChild;

    const rightColStyle = (gridColRightChild, gridColRightEnd) => {
        if (gridColRightChild) {
            if (gridColRightChild.classList.contains('content-wrapper')) {
                gridColRightChild.style.display = 'grid';
                gridColRightChild.style.gridTemplateColumns = `repeat(${gridColRightEnd}, minmax(5.625rem, 6.25rem)) minmax(5.625rem, 1fr)`;
                gridColRightChild.firstElementChild.style.gridColumn = `span ${gridColRightEnd}`;
            }
        }
    }

    if ($(window).width() >= 1080) {
        pageSection.each((idx, column) => {
            let children = column.firstElementChild === null ? null : column.firstElementChild.children;
            let childrenCount = 0;
            let SectionTitleExist;
            if (children) {
                for (let i = 0; i < children.length; i++) {
                    if (children[i].classList.contains('wp-block-jetpack-layout-grid-column')) {
                        childrenCount++;
                    }
                }
                if (children.length > 0) {
                    SectionTitleExist = children[0].firstElementChild !== null && children[0].firstElementChild.classList.contains('wp-block-lazyblock-section-title') === false;
                }
            }
            // ? RIGHT COLUMN LOGIC
            if (childrenCount > 1) {
                gridColRight = children[childrenCount - 1];
                gridColRightStart = window.getComputedStyle(gridColRight, null)['grid-column-start'];
                gridColRightEnd = Number(window.getComputedStyle(gridColRight, null)['grid-column-end'].replace(/[^0-9]/g,'')) - 1;
                gridColRightChild = gridColRight.firstElementChild === null ? null : gridColRight.firstElementChild.firstElementChild;
                rightColStyle(gridColRightChild, gridColRightEnd);
            }
            // ? LEFT COLUMN LOGIC (WITHOUT SECTION TITLE)
            if (childrenCount >= 1 && SectionTitleExist) {
                gridColLeft = children[0];
                gridColLeftStart = Number(window.getComputedStyle(gridColLeft, null)['grid-column-start']);
                if (gridColLeftStart === 1 || gridColLeftStart === 2) {
                    if (gridColLeftStart === 1) {gridColLeftStart += 3;}
                    if (gridColLeftStart === 2) {gridColLeft.style.gridColumnStart = 1; gridColLeftStart += 2;}

                    gridColLeftEnd = Number(window.getComputedStyle(gridColLeft, null)['grid-column-end'].replace(/[^0-9]/g,''));
                    gridColLeftChild = gridColLeft.firstElementChild === null ? null : gridColLeft.firstElementChild.firstElementChild;
                    if (gridColLeftChild) {
                        if (gridColLeftChild.classList.contains('content-wrapper')) {
                            gridColLeftChild.style.display = 'grid';
                            gridColLeftChild.style.gridTemplateColumns = `minmax(5.625rem, 1fr) repeat(${gridColLeftEnd}, minmax(5.625rem, 6.25rem))`;
                            gridColLeftChild.firstElementChild.style.gridColumn = `${gridColLeftStart} / span ${gridColLeftEnd - 2}`;
                        }
                    }
                } else {
                    // ? NOW LEFT COLUMN BASICALLY LOOKS LIKE RIGHT COLUMN
                    gridColLeftEnd = Number(window.getComputedStyle(gridColLeft, null)['grid-column-end'].replace(/[^0-9]/g,'') - 1);
                    gridColLeftChild = gridColLeft.firstElementChild === null ? null : gridColLeft.firstElementChild.firstElementChild;
                    rightColStyle(gridColLeftChild, gridColLeftEnd);
                    // return false;
                }
            }
        })
    }
    // * -------------------->



    $(window).on('resize', () => {
        verticalPageDisHeight();
        checkImgShadow();
    });
    
});